import { StorageObjectGroupType } from '@navio/nsdk';
import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge, type BadgeVariant } from 'noddi-ui-web';
import { STORAGE_OBJECT_GROUP_TYPE_LABEL } from 'noddi-util';
import { STORAGE_OBJECT_GROUP_TYPE_ICON } from './storageObjectGroupTypeIcon';

const VARIANT: Record<StorageObjectGroupType, BadgeVariant> = {
  [StorageObjectGroupType.CAR_WHEELS]: 'default',
  [StorageObjectGroupType.CAR_TIRES]: 'info'
};

export const StorageObjectGroupTypeBadge = ({ type }: { type: StorageObjectGroupType }) => (
  <NoddiBadge variant={VARIANT[type]}>
    <NoddiIcon name={STORAGE_OBJECT_GROUP_TYPE_ICON[type]} size='small' />
    {STORAGE_OBJECT_GROUP_TYPE_LABEL[type]}
  </NoddiBadge>
);
